import { AHText, Box , useTime } from "arkh";

import { useLayoutEffect , useState } from "react";

import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useWorkspaceTimeZone } from "@/src/OS/WorkspaceTimezone";
import { DateTime } from "luxon";
import { WebModalHeader } from "../WorkspaceTodos/WorkspaceTodoEdit/WorkspaceTodoEditMain/WebModalHeader";
import { FormattedMessage } from "react-intl";
import { WebDateSelector } from "@/src/components/mobile/WebDateSelector/WebDateSelector";
import { OrgButton } from "../OrgButton";

export function WorkspaceEditScheduledArchiveAt(props: {
  close: () => void;
  initialArchiveAt?: string | null;
  setOptions: (options: { header: () => React.ReactNode }) => void;
  description: string;
  onArchive: () => void;
  archiveLoading: boolean;
  onSave: (archiveAt: DateTime | null) => void;
  saveLoading: boolean;
}) {
  const [archiveDate, setArchiveDate] = useState<DateTime | null>(
    props.initialArchiveAt ? DateTime.fromISO(props.initialArchiveAt) : null
  );
  const now = useTime();
  const tz = useWorkspaceTimeZone();
  const intl_tokens = useIntlTokens();
  useLayoutEffect(() => {
    props.setOptions({
      header: () => (
        <WebModalHeader
          title={
            <WebModalHeader.Title>
              {intl_tokens.ScheduleArchive}
            </WebModalHeader.Title>
          }
          close={<WebModalHeader.CloseButton onPress={props.close} />}
        />
      ),
    });
  }, [props, intl_tokens.ScheduleArchive]);

  return (
    <Box style={{ flex: 1 }}>
      <Box color="background" cornerRadius="large" style={{ flex: 1 }}>
        <Box style={{ flex: 1 }} space="large">
          <AHText type="title-small">
            <FormattedMessage
              defaultMessage="Archive date"
              description="WorkspaceTodoEditScheduledArchiveAt title"
            />
          </AHText>
          <AHText spaceTop="xsmall" spaceBottom="medium">
            {props.description}
          </AHText>
          <Box
            style={{
              flexDirection: "row",
            }}
          >
            <WebDateSelector
              type="datetime"
              timezone={tz}
              placeholder={
                <FormattedMessage
                  description="WorkspaceTodoEditMain Date Placeholder"
                  defaultMessage="add schedule"
                />
              }
              minDate={now}
              value={archiveDate}
              onChangeValue={(val) => {
                setArchiveDate(val);
              }}
            />
          </Box>
        </Box>
        <Box
          style={{ flexDirection: "row", justifyContent: "flex-end" }}
          space="large"
        >
          <Box spaceRight="medium">
            <OrgButton
              title={intl_tokens.ArchiveNow}
              backgroundColor="transparent"
              tintColor="text-secondary"
              loading={props.archiveLoading}
              icon="archive"
              onPress={() => {
                props.onArchive();
              }}
            />
          </Box>
          <OrgButton
            title={intl_tokens.Save}
            backgroundColor="primary"
            tintColor="text-inverted"
            loading={props.saveLoading}
            onPress={() => {
              props.onSave(archiveDate);
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
